/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.31/esri/copyright.txt for details.
*/
import{ManagedFBObject as t}from"./ManagedFBObject.js";class e extends t{constructor(t,e,s){super(t,s),this.attachment=e,this.name=""}dispose(){this.attachment.dispose()}get usedMemory(){return this.attachment.usedMemory}}export{e as ManagedFBOAttachment};
